<template>
  <div
    class="setting-popup"
    v-if="boxData.judgeBox"
    :style="{'top': boxData.fix.y+'px', 'left': boxData.fix.x+'px', 'z-index': boxData.Zindex, }"
    @mousedown="stopDocument($event)"
  >
    <div
      class="setting-popup__drag-area"
      v-on:mousedown="moveStart($event, true)"
      v-on:mousemove="moveArea($event)"
      v-on:mouseup="saveMoveState($event)"
      :style="{'cursor': 'move'}"
    >选择颜色</div>
    <div class="setting-popup__content">
      <div class="setting-popup__recent-color" v-show="recentColors && recentColors.length">
        <div>最近使用</div>
        <ul>
          <li
            v-for="(color, i) in recentColors"
            :key="i"
            :style="{backgroundColor: color.hex}"
            @click="onClickRecentColor(color)"
          ></li>
        </ul>
      </div>
      <picker v-model="colors" @input="updateColor" ref="pickerRef"></picker>
    </div>
    <div class="footer" v-show="!boxData.data.isHideFooter">
      <div class="btn" @click="onConfirm">确认</div>
      <div
        class="btn outline"
        @click="
          random();
          $analysis('word_cloud,click_color_random，文字云_点击_颜色_随机');
        "
      >随机</div>
      <div class="btn outline" @click="close">取消</div>
    </div>

    <div class="setting-popup__close" @click="close">
      <i class="icon-popup-close"></i>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import popup from "../mixins/popup";
// import { Sketch } from 'vue-color'
import Sketch from "./content/colorPickerSketch";
import tinycolor from "tinycolor2";
import Analysis from "../mixins/analysis/materialBu";
// import domToImage from '@/plugins/dom-to-image'
import snap from "@/components/mixins/snap";
import textArtStyle from "@/components//mixins/textArtStyle";
import randomColor from "@/plugins/randomColor";
// const { html2canvas } = require('@/plugins/html2canvas')

const myPopup = {
  ...popup,
  watch: {}
};

export default {
  name: "color-cloud",
  components: {
    picker: Sketch
  },
  mixins: [myPopup, Analysis, snap, textArtStyle],
  data() {
    return {
      spriteType: "color-cloud",
      popupType: "color-cloud",
      color: "#5778fb",
      from: null,
      recentColors: [],
      cacheJudge: null
    };
  },
  computed: {
    colors: {
      get() {
        let color = tinycolor(this.color);
        return {
          // hex: '#194d33',
          // hsl: { h: 150, s: 0.5, l: 0.2, a: 1 },
          // hsv: { h: 150, s: 0.66, v: 0.30, a: 1 },
          // rgba: { r: 25, g: 77, b: 51, a: 1 },
          hex: color.toHexString(),
          hsl: color.toHsl(),
          hsv: color.toHsv(),
          rgba: color.toRgb(),
          a: 1
        };
      },
      set(val) {
        this.color = (val && val.hex) || "";
      }
    },
    colorPopupType() {
      if (this.SelectSprites_Msg.length) {
        return "color_" + this.SelectSprites_Msg[0].type;
      }
    },
    ...mapGetters([
      "TOOL",
      "Tool_Size",
      "TopNav_Size",
      "MaterialPane_Size",
      "BgOperation"
    ]),
    ...mapGetters({
      subtitleObj: 'subtitle/subtitleObj'
    })
  },
  watch: {
    "boxDatas.firstDatas": function(val, oldval) {
      // 判断打开关闭
      const vm = this;
      let popupType = this.spriteType;
      if (val && val[val.length - 1] !== popupType) {
        return;
      }
      let num = Array.indexOf(val, popupType);
      if (num < 0) {
        popupType = this.colorPopupType;
        num = val.indexOf(popupType);
      }
      if (this.boxDatas.firstDatas && this.boxDatas.firstDatas.length > 1) {
        this.from = this.boxDatas.firstDatas[
          this.boxDatas.firstDatas.length - 2
        ];
      }
      this.boxData.judgeBox = !(num < 0); // 判断是否打开

      if (this.TOOL && this.boxData.judgeBox || this.subtitleObj && this.boxData.judgeBox) {
        // 打开的操作
        this.boxData.data = this.dataMsg[popupType];
        this.sprite = this.boxData.data.sprite;
        this.boxData.Zindex = (this.dataMsg.length + 1) * 5;
        this.source = this.boxData.data.source;
        // 有source字段弹窗中的拾色器弹窗
        if (this.source) {
          let rect = this.source.rect;
          if (rect) {
            this.boxData.fix.x = rect.left + 28;
            this.boxData.fix.y = rect.top + 28;
          } else {
            this.boxData.fix.x = this.source.boxData.fix.x + 28;
            this.boxData.fix.y = this.source.boxData.fix.y + 28;
          }

          if (this.boxData.data.posx) {
            this.boxData.fix.x = this.boxData.data.posx + 28;
          }
          if (this.boxData.data.posy) {
            this.boxData.fix.y = this.boxData.data.posy + 28;
          }
        }
        // 无source字段
        else {
          this.boxData.fix.x =
            this.boxData.data.posx != null
              ? this.boxData.data.posx
              : this.TOOL.PfixLeft +
                this.SelectSprites_Msg[0].positionLeft -
                280;
          this.boxData.fix.y =
            this.boxData.data.posy != null
              ? this.boxData.data.posy
              : this.TOOL.PfixTop + this.SelectSprites_Msg[0].positionTop;
        }

        this.color = this.boxData.data.color || this.color; // 设置拾色器打开时的颜色
      }

      if (this.TOOL && !this.boxData.judgeBox && this.cacheJudge) {
      }
      this.cacheJudge = this.boxData.judgeBox;
    },

    "boxData.judgeBox": {
      handler(val) {
        if (!val) {
          this.$bus.emit("cloud.colorPickerClosed", this);
          return;
        }
        this.$nextTick(() => {
          if (this.boxData.data.hasEyedropper === false) {
            this.$refs.pickerRef.toggleEyedropper(false);
          } else {
            this.$refs.pickerRef.toggleEyedropper(true);
          }
        });
      }
    },
  },
  created() {
    this.$bus.on("wordCloud.hidePopups", () => {
      this.boxData.judgeBox = false;
    });
  },
  mounted() {},
  methods: {
    updateColor(obj) {
      // let suffix = this.from ? `.${this.from}` : '' // 后缀名表示此二级窗来自哪个一级窗
      this.$emit("input", obj);
      this.$bus.emit(`cloud.colorPickerInput`, obj, this.boxData.data);
    },
    onClickRecentColor(colorObj) {
      let { hex } = colorObj;
      this.$refs.pickerRef.handlePreset(hex);
    },
    onConfirm() {
      this.$bus.emit(
        `cloud.colorPickerConfirm`,
        this.colors,
        this.boxData.data
      );
      this.boxData.judgeBox = false;
      this.handleRecentColor();
    },
    onReset() {
      this.colors = { hex: "#5778fb" };
    },
    random() {
      const randomNumberInRange = (min, max) =>
        Math.random() * (max - min) + min;
      let s = randomNumberInRange(0.6, 0.99);
      let v = 0.99;
      let cObj = randomColor(s, v);
      this.$refs.pickerRef.handlePreset(cObj.toHexString());
    },
    handleRecentColor() {
      const vm = this;
      let filtered = this.recentColors.filter(color => color.hex === vm.color);
      let hasColor = filtered && filtered.length;
      if (hasColor) {
        let myIndex = this.recentColors.indexOf(filtered[0]);
        let spliced = this.recentColors.splice(myIndex, 1);
        this.recentColors = [...spliced, ...this.recentColors];
      } else {
        this.recentColors.unshift({
          hex: this.color
        });
      }
      this.recentColors = this.recentColors.slice(0, 6);
    },
    close() {
      this.boxData.judgeBox = false;
      this.$bus.emit("FeaturesPop_close_vue", {
        name: "color-cloud",
        type: 1
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../style/colors.scss";

.setting-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 214px;
  height: auto;
  z-index: 35;
  box-shadow: 0 0 3px 1px #d8dee9;
  border-radius: 6px 6px 3px 3px;
  border: 1px solid #d8dee9;
  background-color: $c5;
  overflow: hidden;
  font-size: 14px;

  &__drag-area {
    line-height: 28px;
    background: #d8dee9;
    text-align: left;
    text-indent: 14px;
  }

  &__content {
    padding-top: 12px;
    padding-bottom: 30px;
  }

  &__recent-color {
    > div:first-child {
      text-align: left;
      padding-left: 20px;
      padding-right: 20px;
    }
    > ul {
      display: flex;
      justify-content: flex-start;
      width: 180px;
      margin-top: 8px;
      margin-left: auto;
      margin-right: auto;
      > li {
        width: 30px;
        height: 30px;
        cursor: pointer;
      }
    }
  }

  &__close {
    position: absolute;
    top: 7px;
    right: 12px;
    height: 14px;
    line-height: 14px;
    width: 14px;
    cursor: pointer;
  }
}
.vc-sketch {
  box-shadow: none;
  margin-left: auto;
  margin-right: auto;
}

.footer {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -10px;
  margin-bottom: 20px;
}
.btn {
  padding: 8px 12px;
  background-color: #5778fb;
  box-shadow: 0px 0px 4px 0px rgba(44, 75, 248, 0.2);
  border-radius: 4px;
  color: #fff;
  cursor: pointer;

  &.outline {
    margin-left: 8px;
    background-color: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(44, 75, 248, 0.2);
    border-radius: 4px;
    color: #333;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popups/colorCloud.vue